const outerImage = require('../assets/iv-stand/paper-doll-site-exterior.png');
const innerImage = require('../assets/iv-stand/paper-doll-site-interior.png');

const locations = {
  CHEST: {
    site: 'IO_STERNUM',
    side: 'BOTH',
    coords: {
      'FEMALE': {
        left: 142,
        top: 135
      },
      'MALE': {
        left: 142,
        top: 128
      }
    },
  },
  NECK_RIGHT: {
    site: 'IV_EJ',
    side: 'RIGHT',
    coords: {
      'FEMALE': {
        left: 125,
        top: 66
      },
      'MALE': {
        left: 125,
        top: 66
      }
    },
  },
  NECK_LEFT: {
    site: 'IV_EJ',
    side: 'LEFT',
    coords: {
      'FEMALE': {
        left: 161,
        top: 66
      },
      'MALE': {
        left: 161,
        top: 66
      }
    },
  },
  HUMERUS_RIGHT: {
    site: 'IO_HUMERUS',
    side: 'RIGHT',
    coords: {
      'FEMALE': {
        left: 80,
        top: 100
      },
      'MALE': {
        left: 70,
        top: 100
      }
    },
  },
  HUMERUS_LEFT: {
    site: 'IO_HUMERUS',
    side: 'LEFT',
    coords: {
      'FEMALE': {
        left: 206,
        top: 100
      },
      'MALE': {
        left: 220,
        top: 100
      }
    },
  },
  ANTECUBITAL_RIGHT: {
    site: 'IV_ANTECUBITAL',
    side: 'RIGHT',
    coords: {
      'FEMALE': {
        left: 57,
        top: 196
      },
      'MALE': {
        left: 59,
        top: 200
      }
    },
  },
  ANTECUBITAL_LEFT: {
    site: 'IV_ANTECUBITAL',
    side: 'LEFT',
    coords: {
      'FEMALE': {
        left: 227,
        top: 196
      },
      'MALE': {
        left: 226,
        top: 200
      }
    },
  },
  FOREARM_RIGHT: {
    site: 'IV_FOREARM',
    side: 'RIGHT',
    coords: {
      'FEMALE': {
        left: 34,
        top: 224
      },
      'MALE': {
        left: 37,
        top: 228
      }
    },
  },
  FOREARM_LEFT: {
    site: 'IV_FOREARM',
    side: 'LEFT',
    coords: {
      'FEMALE': {
        left: 250,
        top: 224
      },
      'MALE': {
        left: 250,
        top: 228
      }
    },
  },
  HAND_RIGHT: {
    site: 'IV_HAND',
    side: 'RIGHT',
    coords: {
      'FEMALE': {
        left: 18,
        top: 274
      },
      'MALE': {
        left: 20,
        top: 275
      }
    },
  },
  HAND_LEFT: {
    site: 'IV_HAND',
    side: 'LEFT',
    coords: {
      'FEMALE': {
        left: 267,
        top: 274
      },
      'MALE': {
        left: 266,
        top: 275
      }
    },
  },
  ILIAC_CREST_RIGHT: {
    site: 'IO_ILIAC_CREST',
    side: 'RIGHT',
    coords: {
      'FEMALE': {
        left: 108,
        top: 243
      },
      'MALE': {
        left: 109,
        top: 245
      }
    },
  },
  ILIAC_CREST_LEFT: {
    site: 'IO_ILIAC_CREST',
    side: 'LEFT',
    coords: {
      'FEMALE': {
        left: 177,
        top: 243
      },
      'MALE': {
        left: 176,
        top: 245
      }
    },
  },
  DISTAL_FEMUR_RIGHT: {
    site: 'IO_DISTAL_FEMUR',
    side: 'RIGHT',
    coords: {
      'FEMALE': {
        left: 123,
        top: 403
      },
      'MALE': {
        left: 111,
        top: 386
      }
    },
  },
  DISTAL_FEMUR_LEFT: {
    site: 'IO_DISTAL_FEMUR',
    side: 'LEFT',
    coords: {
      'FEMALE': {
        left: 162,
        top: 403
      },
      'MALE': {
        left: 176,
        top: 386
      }
    },
  },
  PROXIMAL_TIBIA_RIGHT: {
    site: 'IO_PROXIMAL_TIBIA',
    side: 'RIGHT',
    coords: {
      'FEMALE': {
        left: 123,
        top: 456
      },
      'MALE': {
        left: 106,
        top: 438
      }
    },
  },
  PROXIMAL_TIBIA_LEFT: {
    site: 'IO_PROXIMAL_TIBIA',
    side: 'LEFT',
    coords: {
      'FEMALE': {
        left: 162,
        top: 456
      },
      'MALE': {
        left: 182,
        top: 438
      }
    },
  },
  DISTAL_TIBIA_RIGHT: {
    site: 'IO_DISTAL_TIBIA',
    side: 'RIGHT',
    coords: {
      'FEMALE': {
        left: 134,
        top: 536
      },
      'MALE': {
        left: 120,
        top: 526
      }
    },
  },
  DISTAL_TIBIA_LEFT: {
    site: 'IO_DISTAL_TIBIA',
    side: 'LEFT',
    coords: {
      'FEMALE': {
        left: 152,
        top: 536
      },
      'MALE': {
        left: 166,
        top: 526
      }
    },
  },
  FOOT_RIGHT: {
    site: 'IV_FOOT',
    side: 'RIGHT',
    coords: {
      'FEMALE': {
        left: 128,
        top: 554
      },
      'MALE': {
        left: 109,
        top: 546
      }
    },
  },
  FOOT_LEFT: {
    site: 'IV_FOOT',
    side: 'LEFT',
    coords: {
      'FEMALE': {
        left: 157,
        top: 554
      },
      'MALE': {
        left: 179,
        top: 546
      }
    },
  },
};

export default {
  outerImage,
  innerImage,
  locations
};